import React, {Component} from 'react';
import Styles from './style.css';
import {dataRegister} from "../../services/dataRegister";
import cx from "classnames";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import 'cropperjs/dist/cropper.css';
import BoosterHeader from "../../components/booster-header/component";
import {quotesRegister} from "../../services/quotesRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {langRegister} from "../../services/langRegister";
import {themeRegister} from "../../services/themeRegister";

class BoosterThemeCustom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            themes: [],
            selected: null
        };
    };

    componentWillMount() {

        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/theme');
            ReactGA4.send({ hitType: "pageview", page: "/booster/theme" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

        this.update.theme();
        this.update.themes();

    }

    update = {
        theme: () => {
            if(themeRegister.getValue()){
                this.setState({
                    selected: themeRegister.getValue()
                })
            }
        },
        themes: () => {
            let themes = [
                {id: 1, title: "branding"},
                {id: 2, title: "profile"}
            ];
            this.setState({
                themes: themes
            })
        }
    };

    functions = {
        default: () => {
            let view = quotesRegister.getView();
            if(view === "custom"){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans-custom");
            }else{
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans");
            }
        },
        theme: (id) => {

        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("signup-image", item);
        }
    };

    render() {
        return (
            <div>
                <BoosterHeader props={this.props}/>
                <div className={Styles.containerOuter}>
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            Select theme
                        </div>
                        <div className={cx(Styles.imagesContainer)}>
                            <div onClick={() => this.functions.default()} className={cx(Styles.imagesContainerItem)}>
                                <div className={Styles.imagesContainerItemInner}>
                                    Default
                                </div>
                            </div>
                            {
                                this.state.themes.map((item) => {
                                    return(
                                        <div onClick={() => this.functions.theme(item.id)} className={cx(Styles.imagesContainerItem)}>
                                            <div className={Styles.imagesContainerItemInner}>
                                                {
                                                    item.id === this.state.selected &&
                                                    <div className={Styles.imagesContainerItemActive}/>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {
                            <div
                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images")}
                                className={cx(Styles.backButton)}>
                                {this.renders.text("item_29")}
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default BoosterThemeCustom;


// WEBPACK FOOTER //
// ./src/pages/booster-theme-custom/component.js